
import { useState, useEffect } from "react";

const Dash = ({ dashboard }) => {
  const base = import.meta.env.VITE_API_BASE_URL;
  const url = base + "graphs/public-dashboards/" + dashboard.dashboard_public_id;
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 818); // grafana's `sm` breakpoint is 768px
    };

    handleResize(); // Check on component mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const iframeHeight = isMobile
    ? dashboard.dashboard_height * 1.5
    : dashboard.dashboard_height;

  return <iframe
    src={url}
    width="100%"
    height={iframeHeight + "px"}
  ></iframe>;
};

export default Dash;
